import {Routes} from '@angular/router'
import {HOME_ROUTE_PATH, LOGIN_ROUTE_PATH} from './application/data-types'
import {adminAuthGuard, LoginComponent} from '@sparbanken-syd/sparbanken-syd-bankid'

export default [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: LOGIN_ROUTE_PATH
  },
  {
    path: HOME_ROUTE_PATH,
    loadChildren: () => import('./home/home-routes').then(r => r.HOME_ROUTES),
    canActivate: [adminAuthGuard]
  },
  {
    path: LOGIN_ROUTE_PATH,
    component: LoginComponent
  },
  {
    path: '**',
    redirectTo: LOGIN_ROUTE_PATH
  }
] satisfies Routes